import { render, staticRenderFns } from "./EhrNavPanel.vue?vue&type=template&id=010cdc5c&scoped=true&lang=pug"
import script from "./EhrNavPanel.vue?vue&type=script&lang=js"
export * from "./EhrNavPanel.vue?vue&type=script&lang=js"
import style0 from "./EhrNavPanel.vue?vue&type=style&index=0&id=010cdc5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010cdc5c",
  null
  
)

export default component.exports